import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  IonBadge,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonIcon,
  IonImg,
  IonText,
} from "@ionic/react";
import { calendarOutline, cardOutline, peopleOutline, personOutline } from "ionicons/icons";

import "./styles/LessonCard.scss";
import { FormattedDate, FormattedTime } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import useLessonsByGroupLogId from "../../../../hooks/lessons/useLessonsByGroupLogId";

function isSubscriptionActive(start_date, end_date) {
  const now = new Date();
  return (
    now >= new Date(start_date.seconds * 1000) &&
    now <= new Date(end_date.seconds * 1000)
  );
}

function LessonCard({ data, imageUrl = "ticket.png", className }) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const {
    data: lessons,
    error: lessonError,
    isLoading: isLoadingLessonData,
  } = useLessonsByGroupLogId(data.id, !isDetailsOpen);
  const {
    id,
    from_date,
    to_date,
    description,
    paid,
    payment_date,
    payment_channel,
    user_full_name,
    athlete,
  } = data;

  console.log("data", data);
  const recoverData = {};
  const lessonsNotRecovered = [];


  if (data.deletedLessons && data.deletedLessons.length > 0) {
    for (const lesson of data.deletedLessons) {
      if (lesson.recovered_by) {
        recoverData[lesson.recovered_by.lesson_id] = lesson;
      } else {
        lessonsNotRecovered.push(lesson);
      }
    }
  }

  return (
    <IonCard
      key={id}
      style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
      className={
        className ? `LessonCard ${className}` : "LessonCard"
      }
    >
      <IonImg
        src={imageUrl}
        style={{
          width: "55px",
          paddingLeft: "1rem",
          boxSizing: "content-box",
        }}
      />
      <IonCardContent style={{ flex: 1, paddingLeft: "1rem" }}>
        <IonText>
          <h5>
            <IonIcon icon={calendarOutline}></IonIcon>
            <FormattedDate
              value={from_date._seconds * 1000}
              day="2-digit"
              month="2-digit"
              year="2-digit"
            />
            &nbsp;-&nbsp;
            <FormattedDate
              value={to_date._seconds * 1000}
              day="2-digit"
              month="2-digit"
              year="2-digit"
            />
          </h5>
        </IonText>
        <IonCardTitle>{description}</IonCardTitle>
        {athlete && (
          <IonText>
            <h5>
              <IonIcon icon={peopleOutline}></IonIcon>
              {`${athlete.fullName}`}
            </h5>
          </IonText>
        )}
        {data.lessonsToRecover && data.lessonsToRecover > 0 ? (
          <IonBadge color="danger">Lezioni da recuperare</IonBadge>
        ) : (
          ""
        )}
      </IonCardContent>
      <IonCardContent
        style={{
          flex: "0 1 auto",
          paddingLeft: "1rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <IonButton
          fill="clear"
          onClick={(e) => {
            e.stopPropagation();
            setIsDetailsOpen(!isDetailsOpen);
          }}
        >
          <FontAwesomeIcon
            icon={faChevronUp}
            style={{
              fontSize: "1.5em",
            }}
          />
        </IonButton>
      </IonCardContent>
      {isDetailsOpen && (
        <IonCardContent
          style={{
            flexBasis: "100%",
          }}
        >
          <h2>Diario lezioni</h2>
          <div key={data.id}>
            <h6>
              {data.description}
              &nbsp;-&nbsp;(
              <FormattedDate
                value={data.from_date._seconds * 1000}
                day="2-digit"
                month="2-digit"
                year="2-digit"
              />
              &nbsp;-&nbsp;
              <FormattedDate
                value={data.to_date._seconds * 1000}
                day="2-digit"
                month="2-digit"
                year="2-digit"
              />
              )
            </h6>
            <h6>
              Lezioni svolte {data.lessons || "-"} su{" "}
              {data.minimum_lessons} pianificate
            </h6>
            <ul>
              {(lessons || []).map((lesson) => (
                <li key={lesson.id}>
                  <FormattedDate
                    value={lesson.to_date.seconds * 1000}
                    day="2-digit"
                    month="2-digit"
                    year="2-digit"
                    weekday="long"
                  />
                  &nbsp;-&nbsp;
                  <FormattedTime
                    value={lesson.from_date.seconds * 1000}
                    hour="2-digit"
                    minute="2-digit"
                  />
                  {lesson.is_recover && (
                    <>
                      <IonText color="primary" style={{ fontWeight: "bold" }}>
                        &nbsp;R
                      </IonText>
                      {lesson.lesson_id in recoverData &&
                        lesson.lesson_id !== recoverData[lesson.lesson_id].id && (
                          <IonText color="primary" style={{ fontWeight: "bold", textDecoration: "line-through" }}>
                            <br />
                            <FormattedDate
                              value={recoverData[lesson.lesson_id].to_date._seconds * 1000}
                              day="2-digit"
                              month="2-digit"
                              year="2-digit"
                              weekday="long"
                            />
                            &nbsp;-&nbsp;
                            <FormattedTime
                              value={recoverData[lesson.lesson_id].from_date._seconds * 1000}
                            />
                          </IonText>
                        )}
                    </>
                  )}
                </li>
              ))}
              {(lessonsNotRecovered || []).map((lesson) => (
                <li key={lesson.id}>
                  <IonText color="primary" style={{ fontWeight: "bold", textDecoration: "line-through" }}>
                    <FormattedDate
                      value={lesson.to_date._seconds * 1000}
                      day="2-digit"
                      month="2-digit"
                      year="2-digit"
                      weekday="long"
                    />
                    &nbsp;
                    <FormattedTime
                      value={lesson.from_date._seconds * 1000}
                    />
                  </IonText>
                </li>
              ))}
            </ul>
          </div>
        </IonCardContent>
      )}
    </IonCard>
  );
}

LessonCard.propTypes = {
  href: PropTypes.string,
  imageUrl: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
    start_date: PropTypes.shape({ seconds: PropTypes.number }),
    end_date: PropTypes.shape({ seconds: PropTypes.number }),
    participants: PropTypes.array,
    fieldName: PropTypes.string,
    clubName: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    paid: PropTypes.bool,
    payment_date: PropTypes.shape({ seconds: PropTypes.number }),
    payment_channel: PropTypes.string,
  }),
};

export default LessonCard;
